import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import isEmpty from 'lodash/isEmpty';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import ScheduleCard from './schedule-card';
import { addNewFlightItem } from '../../hooks/use-get-default-values';
import { TicketSaleFormType } from '../form-type';

export default function ScheduleSection() {
  const { t } = useTranslation();
  const { control, formState, trigger } = useFormContext<TicketSaleFormType>();
  const name = 'flightSales' as const;

  const { fields, append, remove } = useFieldArray({
    control,
    name,
    keyName: '__customId',
  });

  const onAdd = React.useCallback(() => {
    append(addNewFlightItem());
    trigger(name);
  }, [append, trigger]);

  const onRemove = React.useCallback((index) => remove(index), [remove]);

  const { editable } = useFormState();

  return (
    <div>
      {fields.map((field, idx) => {
        const isParentError = !isEmpty(formState?.errors?.flightSales?.[idx]);
        return (
          <React.Fragment key={field.customId}>
            <ScheduleCard
              parentIndex={idx}
              onRemove={() => onRemove(idx)}
              fieldLength={fields.length}
              isParentError={isParentError}
            />
            <SeparatorVertical $margin={20}>
              <div style={{ height: 1, width: 4 }} />
            </SeparatorVertical>
          </React.Fragment>
        );
      })}
      {editable && (
        <Button buttonType="secondary" onClick={onAdd}>
          {t('common:add_extra', { extra: t('ticketSales:schedule') })}
        </Button>
      )}
    </div>
  );
}
